import { Icon } from "@iyk/ui"
import { Link } from "react-router"
import { Routes } from "./link.tsx"

export const BackToProfileButton = () => {
  return (
    <Link to={Routes.home} className="text-xs flex items-center gap-0.5 z-10">
      <Icon.ChevronLeft /> Back to profile
    </Link>
  )
}
